import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "App";

import Auth0ProviderWithNavigate from 'services/auth/Auth0';

// Soft UI Context Provider
import { SoftUIControllerProvider } from "hooks/context";


import {
  useQuery,
  useMutation,
  useQueryClient,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query'


import { ReactQueryDevtools } from '@tanstack/react-query-devtools'


// Create a client
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Auth0ProviderWithNavigate>
    <QueryClientProvider client={queryClient}>
      

        <SoftUIControllerProvider>

          <App />

        </SoftUIControllerProvider>

      
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </Auth0ProviderWithNavigate>
);